import { SetStateAction, WritableAtom, atom } from "jotai";
import { RESET } from "jotai/utils";
import { AtomFamily } from "jotai/utils/atomFamily";

import { sessionIdAtom } from "atoms/sessionId";

// Helper function that prevents the need for passing sessionId for setting/getting atoms
export const createDerivedSessionAtom = <Value>(
  sessionBasedAtom: AtomFamily<
    string,
    WritableAtom<Promise<Value>, SetStateAction<Value> | typeof RESET, Promise<void>>
  >
) =>
  atom(
    (get) => get(sessionBasedAtom(get(sessionIdAtom))),
    (get, set, update: SetStateAction<Value>) => set(sessionBasedAtom(get(sessionIdAtom)), update)
  );
